var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifiedUser = function SvgVerifiedUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified-user_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .667 2 3.333v4c0 3.7 2.56 7.16 6 8 3.44-.84 6-4.3 6-8v-4L8 .667ZM6.667 11.333 4 8.666l.94-.94 1.727 1.72 4.393-4.393L12 6l-5.333 5.333Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified-user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgVerifiedUser;